import { BaseContainerModel } from '../base-container.model';
import {
  bl_fi_generic_doc_event_RowClass,
} from '../../dbschema/index';

export class GenericDocEventsContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_event: bl_fi_generic_doc_event_RowClass = new bl_fi_generic_doc_event_RowClass();
}
